import { Injectable } from '@angular/core';
import { UUID } from 'angular2-uuid';


@Injectable({
  providedIn: 'root'
})
export class UuidService {
  public uuidValue = '';

  constructor() { }

  public generateUUID(){
    this.uuidValue=UUID.UUID();
    return this.uuidValue;
  }

  public generateFormattedUUID() {
    var uuid = UUID.UUID();
    var formattedUUID = uuid.toLowerCase().replace(/[^a-zA-Z 0-9]+/g, "");
    console.log("UUID", uuid, formattedUUID);
    return formattedUUID;
  }
}
